const useClientShare = (
  setClientShareModalParams,
  setIsOpenClientShareModal,
  setClientShareConfirmed,
  pesquisaObjetos
) => {
  const groupSearchsByProductGroup = (data) => {
    const searchs = data
      .filter((search) => search.ativo && !search.deletedAt && !search.deletadoEm)
      .map((e) => {
        const pesquisaPlayer = pesquisaObjetos?.pesquisaPlayers?.pesquisaPlayerObjeto["id-" + e.pesquisaPlayerId] ?? "";
        const pesquisaGrupoMaterial =
          pesquisaObjetos.pesquisaGrupoMateriais?.pesquisaGrupoMaterialObjeto["id-" + e.pesquisaGrupoMaterialId];

        return {
          grupoProdutoId: e.pesquisaGrupoMaterialId,
          grupoNome: pesquisaGrupoMaterial?.nome,
          playerId: e.pesquisaPlayerId,
          playerNome: pesquisaPlayer?.nome,
        };
      });

    const groups = searchs.reduce((acc, obj) => {
      const key = obj.grupoProdutoId;
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(obj);
      return acc;
    }, {});

    return groups;
  };

  const verifyClientShare = (data) => {
    const searchs = groupSearchsByProductGroup(data);

    const clientShareAllVotorantim = Object.values(searchs)
      .filter((item) => item.filter((grupo) => grupo.playerNome != "VOTORANTIM").length == 0)
      .map((a) => a[0].grupoNome);

    const clientShareNoneVotorantim = Object.values(searchs)
      .filter((item) => item.filter((grupo) => grupo.playerNome == "VOTORANTIM").length == 0)
      .map((a) => a[0].grupoNome);

    let shouldOpenModalUpdate = true;

    if (clientShareAllVotorantim?.length > 0) {
      setClientShareModalParams((prev) => ({
        ...prev,
        gruposProdutoVotorantim: clientShareAllVotorantim,
      }));

      shouldOpenModalUpdate = false;
    }

    if (clientShareNoneVotorantim?.length > 0) {
      setClientShareModalParams((prev) => ({
        ...prev,
        gruposProdutoConcorrencia: clientShareNoneVotorantim,
      }));

      shouldOpenModalUpdate = false;
    }

    if (shouldOpenModalUpdate) setClientShareConfirmed(true);
    else setIsOpenClientShareModal(true);
  };

  return {
    verifyClientShare,
  };
};

export default useClientShare;
